// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e2bd7ceaec40fecba63f96fa218221798c2c3cef/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};